import * as types from "./actionTypes";


export const get = ()=>{
  return{
    type: types.API_CALL_BANK_REQUEST
  }
};
export const put = data => {
    return {
        type: types.PUT_BANK,
        payLoad: { ...{ loading: false }, ...data }
    };
};
